import { Button, CircularProgress, Dialog } from '@material-ui/core';
import { useEffect } from 'react';
import { useHistory } from 'react-router';
import _usePanSeed, { PanSeedHookPropsType } from '../../hooks/_usePanSeed';

export const PanSeedCheckNew = (
    props: PanSeedHookPropsType & {
        triggerCheck: boolean;
        checkPanSeedRef?: React.MutableRefObject<((...args: any[]) => void) | null>;
        goBack?: boolean;
        resetTrigger?: any;
    },
) => {
    const { triggerCheck, checkPanSeedRef, resetTrigger, goBack = true, ...rest } = props;
    const { open, setOpen, panSeedLoading, redirectPath, message, checkPanSeed } = _usePanSeed({
        ...rest,
    });

    useEffect(() => {
        if (triggerCheck) {
            checkPanSeed();
            resetTrigger && resetTrigger();
        }
    }, [triggerCheck]);

    useEffect(() => {
        if (checkPanSeedRef) {
            checkPanSeedRef.current = checkPanSeed;
        }
    }, [checkPanSeedRef]);

    return (
        <>
            <PanSeedCheckInvalid
                open={open}
                setOpen={setOpen}
                message={message}
                redirectPath={redirectPath}
                heading={'PAN - Aadhar Status Check'}
                goBack={goBack}
            />
            <Dialog
                maxWidth={'sm'}
                open={panSeedLoading}
                aria-labelledby="enable-fingerprint-modal"
            >
                <div className="enable-fingerprint-modal">
                    <CircularProgress />
                    <p style={{ marginTop: '12px' }}>{'Checking PAN-Aadhar link status...'}</p>
                </div>
            </Dialog>
        </>
    );
};

const PanSeedCheckInvalid = ({
    open,
    setOpen,
    message,
    heading,
    redirectPath,
    goBack,
}: {
    open: boolean;
    setOpen: React.Dispatch<React.SetStateAction<boolean>>;
    message: string;
    heading: string;
    redirectPath: string;
    goBack: boolean;
}) => {
    const history = useHistory();
    return (
        <Dialog maxWidth={'sm'} open={open} aria-labelledby="note-modals">
            <div className="note-modals">
                <h3>{heading}</h3>
                <p>{message}</p>
                <div className="note-modals-btns">
                    <Button
                        className="customBtn"
                        id="ok-btn"
                        onClick={() => {
                            setOpen(false);
                            if (redirectPath) {
                                history.replace(redirectPath);
                            } else if (goBack) {
                                history.goBack();
                            }
                        }}
                    >
                        OK
                    </Button>
                    {redirectPath && (
                        <Button
                            id="cancel-btn"
                            className="customBtn cancelBtn"
                            onClick={() => {
                                setOpen(false);
                                if (goBack) history.goBack();
                            }}
                        >
                            Cancel
                        </Button>
                    )}
                </div>
            </div>
        </Dialog>
    );
};
